<template>
<div id="wrapper">
  <Header/>
  <div class="bgLayer"></div>
  <div class="PageAnimation" v-bind:class="{ initPosition: initOpen, after: (isOpen && !initOpen), before: (!isOpen && !initOpen)}">
    <div class="innerBgLayer"></div>
    <div class="opening">
      <p class="mamadaysLogo"><img src="@/assets/images/mamadays_linelogo.png" alt="MAMADAYS 総選挙"></p>
      <div class="progress" v-bind:class="{ active: !isFirstLoad}">
        <span class="bar">
          <span class="current"><figure class="chick"></figure></span>
        </span>
        <p class="loading"><img src="@/assets/images/loading.png" alt="loading..."></p>
      </div>
    </div>
  </div>
  <router-view/>
  <Footer/>
</div>
</template>


<script>
import store from '@/store/index'
import lineAnimation from '@/lineAnimation/generateAnimation'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import util from '@/jsUtil/util'
import lottie from 'lottie-web';
export default {

  components: {
    Footer,
    Header
  },

  data () {
    return {
      isOpen: false,
      initOpen: false,
      isFirstLoad: true,
      unsubscribe: null,
      chickAnimation: null,
    }
  },

  created () {
    this.getCategorysDefinition(500,60);
    this.getDepartments(500,60);
  },

  mounted () {
    this.unsubscribe = store.subscribe((mutation, state) => {
      switch(mutation.type) {
        case "toggleOpen":
          this.isOpen = state.isOpen
          break;
        case "toggleInitOpen":
          this.initOpen = state.initOpen
          break;
        case "alreadyLoad":
          this.isFirstLoad = state.isFirstLoad
          //オープニングアニメーション後になり、もう表示されないので、ひよこのアニメーションを削除する
          setTimeout(()=>{
            this.chickAnimation.pause();
            lottie.destroy(this.chickAnimation.name);
            this.chickAnimation.destroy();
            this.chickAnimation = null;
          },5000);
          break;
      }
    });
    // 描画処理がヘビーなのがうざいので一旦除去 本番時は復活させる。
    lineAnimation();
    this.generateChick();
  },

  methods: {
    async getCategorysDefinition(delay, numOfTime) {
      store.dispatch("setCategoryDefinitions",{ delay: delay, numOfTime: numOfTime });
    },

    async getDepartments(delay, numOfTime) {
      store.dispatch("setDepartments", { delay: delay, numOfTime: numOfTime });
    },

    generateChick(){
      let chickElm = document.querySelector(".PageAnimation .chick");
      this.chickAnimation = lottie.loadAnimation({
        container: chickElm,
        renderer: 'svg',
        name: "openingChick",
        loop: true,
        autoplay: false,
        path: '/animations/hiyoko.json'
      });
      this.chickAnimation.play();
    }
  },

  beforeUnmount() {
    this.unsubscribe();
    this.unsubscribe = null;
  }
}
</script>

<style lang="scss">
.en {
}

.number {
  font-family: 'Quicksand', sans-serif;
  font-weight: 700;
}

.PageAnimation {
  position: fixed;
  display: block;
  top: 0;
  left: 0%;
  width: 100%;
  height: 110%;
  z-index: 9999;
  backface-visibility:hidden;
  overflow: hidden;
  .innerBgLayer {
    position: absolute;
    width: 100%;
    height: 300%;
    backface-visibility:hidden;
    overflow: hidden;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, white 15%, white 40% rgba(255, 255, 255, 0) 51%);
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0, white 15%, white 40% rgba(255, 255, 255, 0) 51%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(255, 255, 255, 0)), color-stop(20%, white), color-stop(40%, white), color-stop(51%, rgba(255, 255, 255, 0)));
    background-repeat: no-repeat;
    background-size: 100% 200%;
    transform-origin: center;
    will-change: top,left;
    @include transition_anim($duration-time: 1.0s, $propertys: (top,left));
    top: 100%;
    left: 0%;
  }
  &.initPosition {
    .innerBgLayer {
      top: 100%;
      left: 0%;
    }
  }
  &.before {
    .innerBgLayer {
      top: -120%;
      left: 0%;
    }
  }
  &.after {
    .innerBgLayer {
      top: -300%;
      left: 0%;
      @include transition_anim($delay-time: 0.5s, $duration-time: 1.0s, $propertys: (top,left));
    }
  }
}

.PageAnimation .opening {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 540px;
  .mamadaysLogo {
    position: absolute;
    width: percent_resize(380,1920);
    min-width: 251px;
    left: 50%;
    top: 27%;
    transform: translate(-50%,-50%);
    img {
      width: 100%;
    }
  }
  .progress {
    width: 100%;
    position: relative;
    padding-top: percent_resize(10,1920);
    left: 0%;
    top: 48%;
    transform: translate(0,-50%);
    &.active {
      .bar {
        .current {
          right: 0%;
        }
      }
    }
    .bar {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      display: block;
      background-color: #FFE3E4;
      .current {
        display: block;
        position: absolute;
        width: 110%;
        height: 100%;
        right: -120%;
        background-color: #F37477;
        will-change: right;
        @include transition_anim($duration-time: 3.6s, $propertys: (right));
        transition-timing-function: linear;
        .chick {
          position: absolute;
          width: percent_resize(130,1920);
          height: percent_resize(95,10);
          bottom: 100%;
          will-change: left;
          left: -5%;
          transform: translate(20%, 21%);
        }
      }
    }
    .loading {
      position: absolute;
      min-width: 117px;
      left: 50%;
      bottom: -900%;
      width: percent_resize(175,1920);
      transform: translate(-50%,-50%);
      will-change: opacity;
      opacity: 1;
      @keyframes transparentation {
        0% { 
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      @include animationProp(transparentation, 4.0s, 0.0s, linear);
      animation-iteration-count: infinite;
    }
  }
}

@include resizebywidth_lessthan($base_resize_size){
  .PageAnimation .opening {
    min-height: initial;
    .mamadaysLogo {
      position: absolute;
      width: percent_resize(221,375);
      min-width: auto;
      left: 50%;
      top: 28%;
      @include resizebyheight_lessthan(550px){
          top: 18%;
      }
    }
    .progress {
      padding-top: percent_resize(6,375);
      @include resizebyheight_lessthan(550px){
          top: 55%;
      }
      .bar {
        .current {
          .chick {
            position: absolute;
            width: 17%;
            left: -12%;
            bottom: 147%;
            height: percent_resize(54,6);
          }
        }
      }
      .loading {
        min-width: auto;
        width: percent_resize(98,375);
        @include resizebyheight_lessthan(550px){
            bottom: -800%;
        }
      }
    }
  }
}

#wrapper {
  width: 100%;
  min-width: 1080px;
  overflow: hidden;
  @include resizebywidth_lessthan($base_resize_size){
    min-width: auto;
  }
}

.text {
  @include font_style_pc;
}

.bgLayer {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100%;
  height: 110%;
  z-index: -100;
  background-color: #FFF4D8;
  will-change: background-color;
  backface-visibility: hidden;
  @include transition_anim($duration-time: 1.0s, $propertys: (background-color));
  &.active {
    background-color: #ffffff;
  }
}

.awards_categorys {
  box-sizing: border-box;
  .categoryItem {
    @include clearfix;
    position: relative;
    .categorys {
      position: relative;
      width: displaysize(630);
      .pageLink {
        color: #BEBEBE;
        font-size: displaysize(23);
        margin-bottom: percent_resize(43,630);
        a {
          color: rgba($color: #F37477, $alpha: 1.0);
          display: inline-block;
          position: relative;
          &:visited { color: rgba($color: #F37477, $alpha: 1.0); }
          &:link { color: rgba($color: #F37477, $alpha: 1.0); }
          opacity: 1.0;
          @include transition_anim();
          &:hover {
            opacity: 0.6;
          }
        }
      }
      .groups {
        a {
          display: block;
          width: 100%;
          height: 100%;
        }
        a:nth-of-type(n + 2) {
          li {
            margin-top: -1px;
          }
        }
        li {
          position: relative;
          padding: percent_resize(25,630) 0 percent_resize(25,630) 0;
          font-size: displaysize(26);
          letter-spacing: 0.03em;
          color: #404040;
          @include transition_anim($duration-time: 1.0s, $propertys: (border-top,border-bottom));
          border-top: 1px solid #CCCCCC;
          border-bottom: 1px solid #CCCCCC;
          z-index: 100;
          &:hover {
            border-top: 1px solid #000000;
            border-bottom: 1px solid #000000;
            z-index: 500;
          }
        }
      }
    }
  }
}

canvas {
	transition-property: filter,opacity;
  transition-timing-function: ease-out;
  will-change: filter,opacity;
  backface-visibility:hidden;
  overflow: hidden;
  opacity: 1.0;
  z-index: 1;
	filter: blur(0px);
	&.active {
    opacity: 0.2;
    filter: blur(8px);
    @include resizebywidth_lessthan($base_resize_size){
      filter: blur(4px);
    }
  }
}
</style>